import { render, staticRenderFns } from "./ResultsView.vue?vue&type=template&id=4e21b4fb&"
import script from "./ResultsView.vue?vue&type=script&lang=ts&"
export * from "./ResultsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports